﻿export * from './login.component';
export * from './change.component';
export * from './social.component';

